import * as React from 'react';
import { Form } from 'react-bootstrap';
import * as _ from 'lodash'
import { copyObject, randomId } from '../utils';
export interface ItemCheckbox {
    value: string
    label: string
    checked: boolean
    disabled?: boolean
}
export type ICheckBoxListProps = {
    data: Array<ItemCheckbox>
    className?: string
    onCheckBoxPress?(value: string, checked: boolean)
    inline?: boolean
    type?: "checkbox" | "radio"
}

const CheckBoxList: React.FC<ICheckBoxListProps> = (props) => {
    const [currentData, setCurrentData] = React.useState([])

    React.useEffect(() => {
        if (!_.isEqual(props.data, currentData)) {
            setCurrentData(props.data)
        }

    }, [props.data]);


    const onCheckBoxPress = (index, item, event) => {
        let cloneData = copyObject(currentData)
        cloneData[index].checked = !cloneData[index].checked
        let checked = cloneData[index].checked
        setCurrentData(cloneData)
        if (props.onCheckBoxPress) {
            props.onCheckBoxPress(item.value, checked)
        }

    }

    /**
     * 
     */
    const renderCheckBoxList = () => {
        const groupid = randomId();
        if (_.isArray(currentData)) {
            return currentData.map((item: ItemCheckbox, index) => {
                let className = `form-control ${props.className}`
                return (

                    <Form.Check
                        disabled={item.disabled}
                        // custom
                        inline={props.inline}
                        id={`${props.inline ? "custom-inline-" : "custom-"}${item.value}-${index}-${groupid}`}
                        key={index}
                        label={item.label}
                        onChange={(event) => onCheckBoxPress(index, item, event)}
                        checked={item.checked}
                        // className={className}
                        type={"checkbox"}
                    />

                )
            })

        }
    }
    return (
        <div>
            <div key={`${props.inline ? "custom-inline-" : "custom-"}${props.type}`}>
                {renderCheckBoxList()}
            </div>
        </div>
    );
}

CheckBoxList.defaultProps = {
    type: "checkbox"
}
export default CheckBoxList;
export { CheckBoxList };